<svg [ngClass]="{cross: isOpen}" class="hamburguer-menu" viewBox="0 0 800 600">
  <path class="top" d="M300,220 C300,220 520,220 540,220 C740,220 640,540 520,420 C440,340 300,200 300,200"></path>
  <path class="middle" d="M300,320 L540,320"></path>
  <path class="bottom" d="M300,210 C300,210 520,210 540,210 C740,210 640,530 520,410 C440,330 300,190 300,190" transform="translate(480, 320) scale(1, -1) translate(-480, -318) "></path>
</svg>